import controllers from "venuescanner-js/services/controllers";

export async function fetchPaymentCapabilities(venueId) {
  const data = await controllers.venue.paymentCapabilities.get({
    venueId: venueId.toString(),
  });

  return data;
}

export async function createQuotePreview({
  venueId,
  amount,
  vatIncluded,
  paymentCapabilities,
  offlinePayment,
}) {
  const data = await controllers.quote.preview.post({
    venueId,
    price: amount.price,
    vatIncluded,
    paymentCapabilities,
    offlinePayment,
    currency: amount.currency,
  });

  return data;
}
